import { experimentationToggles } from './experimentation-toggles'
import { featureToggles } from './feature-toggles'

export const togglesDefinitions = {
  ...featureToggles,
  ...experimentationToggles,
} as const
